import { FC } from 'react'

interface IconCheckMarkProps {
  className?: string
}

export const IconCheckMark: FC<IconCheckMarkProps> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM14.2805 8.2805L9.2805 13.2805C9.134 13.427 8.942 13.5 8.75 13.5C8.558 13.5 8.366 13.427 8.2195 13.2805L5.7195 10.7805C5.4265 10.4875 5.4265 10.013 5.7195 9.72C6.0125 9.427 6.487 9.427 6.78 9.72L8.7495 11.6895L13.219 7.22C13.512 6.927 13.9865 6.927 14.2795 7.22C14.5725 7.513 14.573 7.9875 14.2805 8.2805Z"
        fill="black"
      />
    </svg>
  )
}
